<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-layout pt-2 pb-2 justify-start column>
    <div style="width: calc(100%)">
      <div>
        <SimpleCard>
          <v-layout row wrap align-content-center justify-center>
            <v-flex v-if="loading" xs12 pa-2 class="text-xs-center">
              <v-progress-circular :size="48" :width="5" color="primary" indeterminate></v-progress-circular>
            </v-flex>
            <BookingSummaryList
              @bookingTypesUpdated="updateBookingTypes"
              @locationTypesUpdated="updateLocationTypes"
              @updateTodayBookings="updateTodayBookings"
              v-if="!loading"
              @search="search"
              :query="query"
              style="width: 100%;"
              :bookings="bookings"
              :paginationProp="pagination"
              :rideTypes="rideTypes"
              @reload="getBookings"
            ></BookingSummaryList>
            <v-flex v-if="!loading" pt-2 xs9 class="text-xs-center pt-2">
              <v-pagination @input="changePage" v-model="pagination.page" :length="num_pages"></v-pagination>
            </v-flex>
          </v-layout>
        </SimpleCard>
      </div>
    </div>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import BookingSummaryList from "@/components/booking/BookingSummaryList.vue";
import BookingSearchBox from "@/components/booking/BookingSearchBox.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import moment from "moment";

export default {
  name: "bookings",
  components: {
    SimpleCard,
    BookingSummaryList,
    BookingSearchBox,
  },

  data: function () {
    return {
      bookings: [],
      offset: 0,
      count: 25,
      query: {
        todayBookings: "",
        state: "booked",
        name: "",
        number: "",
        pickup: "",
        destination: "",
        before: "",
        after: "",
        paymentType: "all",
        bookingMethod: "all",
        locationTypes: "",
        refNum: "",
        bookingID: null,
        hideRepeatTrips: false,
        preassignedDriver: "",
        bid: "all",
      },
      loading: true,
      pagination: { page: 1 },
      num_pages: 0,
      rideTypes: [],
      locationTypes: [
        {
          id: 1,
          value: 'airport',
          name: 'Airport',
        },
        {
          id: 2,
          value: 'cruise',
          name: 'Cruise',
        },
        {
          id: 3,
          value: "bus_station",
          name: "Bus Station"
        },
        {
          id: 4,
          value: "doctor",
          name: "Doctor"
        },
        {
          id: 5,
          value: "hospital",
          name: "Hospital"
        },
        {
          id: 6,
          value: "light_rail_station",
          name: "Light Rail Station"
        },
        {
          id: 7,
          value: "local_government_office",
          name: "Local Government Office"
        },
        {
          id: 8,
          value: "primary_school",
          name: "Primary School"
        },
        {
          id: 8,
          value: "school",
          name: "School"
        },
        {
          id: 8,
          value: "secondary_school",
          name: "Secondary School"
        },
        {
          id: 8,
          value: "subway_station",
          name: "Subway Station"
        },
        {
          id: 8,
          value: "tourist_attraction",
          name: "Tourist Attraction"
        },
        {
          id: 8,
          value: "train_station",
          name: "Train Station"
        },
        {
          id: 8,
          value: "transit_station",
          name: "Transit Station"
        },
        {
          id: 8,
          value: "university",
          name: "University"
        },
        {
          id: 8,
          value: "Zoo",
          name: "Zoo"
        },
        {
          id: 8,
          value: "primary_school",
          name: "Primary School"
        },
        {
          id: 8,
          value: "primary_school",
          name: "Primary School"
        },
      ],
      bookingTypes: [
        {
          id: 1,
          value: "phone",
          name: "Phone"
        },
        {
          id: 2,
          value: "app",
          name: "App"
        },
        {
          id: 3,
          value: "website",
          name: "Website"
        },
        {
          id: 4,
          value: "third_party",
          name: "Third Party"
        },
        {
          id: 4,
          value: "flag_down",
          name: "Flag Down"
        },
        {
          id: 4,
          value: "repeat",
          name: "Repeat"
        },
      ],
    };
  },
  computed: {
    bookingsTypeValues () {
      let onlyValues = [];
        this.bookingTypes.forEach(bookingType => {
          onlyValues.push(bookingType.value)
      })
      return onlyValues
    },
    locationTypeValues () {
      let onlyValues = [];
        this.locationTypes.forEach(bookingType => {
          onlyValues.push(bookingType.value)
      })
      return onlyValues
    }
  },
  mounted: async function () {
    if (this.$route.query.bookingID) {
      this.query.bookingID = this.$route.query.bookingID;
      this.query.before = "";
      this.query.state = "all";
    }

    if (this.$route.query.contact_number) {
      this.query.name = this.$route.query.contact_number;
      this.query.before = "";
      this.query.state = "all";
    } else if (this.$route.query.name ){
      this.query.name = this.$route.query.name;
      this.query.before = "";
      this.query.state = "all";
    }

    this.getBookings();
    this.getRideTypes();
  },
  methods: {
    updateTodayBookings () {
      if (this.query.todayBookings) {
        this.count = -1;
        this.query.before = moment().format("YYYY-MM-DD")
        this.query.after = moment().format("YYYY-MM-DD")
      } else {
        this.count = 25
        this.query.before = ""
        this.query.after = ""
      }
      this.getBookings()
    },
    search: function () {
      this.pagination.page = 1;
      this.getBookings();
    },
    updateBookingTypes (payload) {
      if (payload.includes('all')) {
        this.query.bookingMethod = "all"
      } else {
        this.query.bookingMethod = payload.join()
      }
    },
    updateLocationTypes (payload) {
      if (payload.includes('all')) {
        this.query.locationTypes = ""
      } else {
        this.query.locationTypes = payload.join()
      }
    },
    clear: function () {
      this.query.state = "all";
      this.query.name = "";
      this.query.number = "";
      this.query.pickup = "";
      this.query.destination = "";
      this.query.before = "";
      this.query.after = "";
      this.query.paymentType = "all";
      this.query.bookingMethod = "all";
      this.query.refNum = "";
      this.query.bookingID = null;

      this.getBookings();
    },
    changePage: function (page) {
      this.pagination.page = page;
      console.log(page);
      this.getBookings();
    },
    getBookings: async function () {
      this.loading = true;

      try {
        var url;

        // if (this.query.bookingID == null || this.query.bookingID == "") {
        url = `${this.$store.state.apiUrl}/booking/list?offset=${
          this.count * (this.pagination.page - 1)
        }&count=${this.count}&state=${this.query.state}&number=${this.query.number.trim()}&paymentType=${
          this.query.paymentType
        }&before=${
          this.query.before
        }&after=${this.query.after}&hideRepeatTrips=${
          this.query.hideRepeatTrips
        }`;

        if (this.query.locationTypes != null && this.query.locationTypes != "") {
          url += `&locationTypes=${this.query.locationTypes}`
        }
        if (this.query.name != null && this.query.name != "") {
          url += `&name=${this.query.name}`
        }

        if (this.query.refNum != null && this.query.refNum != "") {
          url += `&refNum=${this.query.refNum}`;
        }

        // if (this.query.bookingID != null && this.query.bookingID != "") {
        //   url += `&bookingID=${this.query.bookingID}`;
        // }

        if (this.query.pickup != null && this.query.pickup != "") {
          url += `&pickup=${this.query.pickup}`;
        }

        if (this.query.destination != null && this.query.destination != "") {
          url += `&destination=${this.query.destination}`;
        }
        if (this.query.bookingMethod != null && this.query.bookingMethod !== "") {
          url += `&bookingMethod=${this.query.bookingMethod}`;
        }

        if (this.query.bookingID != null && this.query.bookingID != "") {
          url += `&bookingID=${this.query.bookingID}`;
        }

        if (this.query.preassignedDriver != null && this.query.preassignedDriver != "") {
          url += `&preassignedDriver=${this.query.preassignedDriver}`
        }
        if (this.query.bid) {
          url += `&bidFilter=${this.query.bid}`
        }


        let response = await axios.get(url, {
          params: {},
        });

        var bookings = response.data.bookings;

        for (var i = 0; i < bookings.length; i++) {
          if (bookings[i].preassigned_driver_id == null) {
             bookings[i].preassigned_driver_id = "";
             bookings[i].preassigned_driver_name = "";
             bookings[i].preassigned_driver_callsign = "";
          }
        }

        this.bookings = bookings;

        this.pagination.page = response.data.pages.page;
        this.num_pages = response.data.pages.num_pages;

        console.log(response.data.num_pages);

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get bookings " + error);
      }
    },
    getRideTypes: async function () {
      try {
        var url = `${this.$store.state.apiUrl}/ride_types/all`;

        let response = await axios.get(url, {
          params: {},
        });

        this.rideTypes = response.data;

        this.getRepeatService();

        console.log("got ride types");
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ride types " + error);
      }
    },
    failed: function (data) {
      alert("Request Failed with error: " + data.message);
    },
  },
};
</script>


<style lang="scss">

  .v-select .v-input__icon--append {
    display: none;
  }
</style>